import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import styles from './messageHandler.module.scss';
import MessageSelector from './messageSelector';
import MultipleOptions from './multipleOptions';
import MessageSequencer from './messageSequencer';
import getLabel from './../../../../utils/labels'
import closeIcon from '../../../../globals/images/close.svg';
import addMessageIcon from '../../../../globals/images/add-message.svg';

class MessageHandler extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    openList = () => {
        this.setState({ isOpen: true });
        if (this.props.tutorial.isRunning) {
            this.props.stopTutorial();
            setTimeout(() => {
                this.goToNextTutorialStep();
                this.props.startTutorial();
            }, 650);
        }
    }

    goToNextTutorialStep = () => {
        this.props.updateStepNumber(this.props.tutorial.stepIndex + 1);
    }

    handleClose = () => {
        this.setState({ isOpen: false });
    }

    clearOptions = () => {
        this.props.clearBody(this.props.id);
    }

    getPreText = (preText) => {
        return preText && preText.map((item, key) => <p key={key} dangerouslySetInnerHTML={{ __html: item }} />)
    }

    getPostText = (postText) => {
        return postText && postText.map((item, key) => <p key={key} dangerouslySetInnerHTML={{ __html: item }} />)
    }

    getMultipleOptionText = (options, selectedOptions) => {
        let optionsArray = options.filter(option => {
            if (selectedOptions.includes(option.id)) {
                return option;
            }
        });

        return optionsArray.map((option, key) => (<p key={key} dangerouslySetInnerHTML={{ __html: option.text }} />));
    }

    getSingleOptionText = (options, selectedOptions) => {
        const selectedoption = options.find((option) => option.id === selectedOptions[0]);
        return (<p dangerouslySetInnerHTML={{ __html: selectedoption.text }} />);
    }


    getSelectedText = ({ type, selectedOptions, options }) => {
        if (type === 'mcq') {
            return this.getSingleOptionText(options, selectedOptions);
        } else if (type === 'multiple') {
            return this.getMultipleOptionText(options, selectedOptions);
        }
    }


    render() {
        const {
            type,
            selectedOptions,
            updateBody,
            clearBody,
            postText,
            preText
        } = this.props;

        const selectedOptionBorder = {
            border: 'solid 1px #eeeeee',
            marginTop: '12px',
            padding: '12px 55px 12px 10px'
        };

        return <div className={styles.container} >
            {this.getPreText(preText)}
            <div className={styles['container-box']} style={selectedOptions ? selectedOptionBorder : {}}>
                {
                    selectedOptions ?
                        <Fragment>
                            {this.getSelectedText(this.props)}
                            <img className={styles['close-button']} src={closeIcon} onClick={this.clearOptions} />
                        </Fragment>
                        :
                        <Fragment>
                            <div className={styles['button-holder']}  >
                                <div onClick={this.openList} className={styles['select-button']} id="tutorial-add-message">
                                    <div className={styles['add-message-button']}>
                                        <img src={addMessageIcon} className={styles['add-message-icon']} />
                                    </div>
                                    <div className={styles['add-message-text']} >{getLabel('label_add_message_button')}</div>
                                </div>
                                {
                                    this.props.isFirstMail ?
                                        <div className={styles.warning}>
                                            {getLabel('label_add_message_info')}
                                        </div>
                                        :
                                        null
                                }
                            </div>
                        </Fragment>
                }

                {
                    this.state.isOpen && type === 'mcq' ?
                        <MessageSelector
                            {...this.props}
                            handleClose={this.handleClose}
                            updateBody={updateBody}
                        />
                        :
                        null
                }
                {
                    this.state.isOpen && type === 'multiple' ?
                        <MultipleOptions
                            {...this.props}
                            handleClose={this.handleClose}
                            updateBody={updateBody}
                        />
                        :
                        null
                }
                {
                    this.state.isOpen && type === 'list' ?
                        <MessageSequencer
                            {...this.props}
                            handleClose={this.handleClose}
                            updateBody={updateBody}
                        />
                        : null
                }
            </div>
            {this.getPostText(postText)}
        </div>
    }
}

MessageHandler.propTypes = {
    messageOptions: PropTypes.object,
    isMessageSelctor: PropTypes.bool,
    updateBody: PropTypes.func,
    selectedOptions: PropTypes.array,
    isMessageArranger: PropTypes.bool,
    options: PropTypes.array,
};

MessageHandler.defaultProps = {};

export default MessageHandler;


// WEBPACK FOOTER //
// /src/components/mailThread/compose/messageHandler/MessageHandler.js